import { Box, Chip, Grid } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import IconButtonIcons from "./IconButtonIcons";

// Optional: resolveUrl (preview path -> URL), move(from, to) to enable reordering, coverLabel for the first image.
function ImagesGallery({ images, remove, resolveUrl = (url) => url, move, coverLabel }) {
    return (
        <Grid display={"flex"} flexDirection={"row"} flexWrap={"wrap"} >
            {
                images && images.length > 0 && images.map((url, key) => {
                    return (
                        <Box key={`${url}-${key}`} flexDirection={"row"} sx={{ position: "relative", px: 2, py: 1 }}>
                            <Box sx={{ position: "absolute", right: 0, backgroundColor: "#fff", borderRadius: 50 }}>
                                <IconButtonIcons IconComponent={CloseIcon}   color="primary" title="Remove" onClick={() => remove(key)} />
                            </Box>
                            <img src={resolveUrl(url)} alt="someimg" width={100} style={{ padding: 2 }} />
                            {coverLabel && key === 0 ? (
                                <Chip label={coverLabel} size="small" color="primary" sx={{ position: "absolute", left: 20, top: 12 }} />
                            ) : null}
                            {move ? (
                                <Box sx={{ display: "flex", justifyContent: "center" }}>
                                    <IconButtonIcons IconComponent={ArrowBackIcon} color="primary" title="Move left" disabled={key === 0} onClick={() => move(key, key - 1)} />
                                    <IconButtonIcons IconComponent={ArrowForwardIcon} color="primary" title="Move right" disabled={key === images.length - 1} onClick={() => move(key, key + 1)} />
                                </Box>
                            ) : null}
                        </Box>
                    )
                })
            }
        </Grid>
    )
}
export default ImagesGallery;